import { Directive, ElementRef, forwardRef, HostListener, inject, Renderer2 } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';

export const LAENDERVORWAHL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MngLaendervorwahlFieldDirective),
  multi: true
};

export const LAENDERVORWAHL_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => MngLaendervorwahlFieldDirective),
  multi: true
};

@Directive({
  selector: '[mngLaendervorwahlField]',
  providers: [LAENDERVORWAHL_VALUE_ACCESSOR, LAENDERVORWAHL_VALIDATOR]
})
export class MngLaendervorwahlFieldDirective implements ControlValueAccessor, Validator {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  @HostListener('change', ['$event.target.value']) onChange = (value: any) => {
    return;
  };

  @HostListener('blur', []) onTouched = () => {
    return;
  };

  @HostListener('input', ['$event.target.value']) onInput = this.onChange;

  /**
   * Wert --> HTML Element
   */
  writeValue(value: string) {
    // MODEL -> VIEW
    if (value && value.length > 1) {
      const viewValue = replaceLeadingDoubleZeroWithPlus(value);
      this.renderer.setProperty(this.elementRef.nativeElement, 'value', viewValue);
    }
  }

  registerOnChange(fn: (_: any) => void) {
    // VIEW -> MODEL
    this.onChange = (value) => {
      if (value && value.length > 1) {
        fn(replaceLeadingDoubleZeroWithPlus(value));
      } else if (value) {
        fn(value);
      } else {
        fn(null);
      }
    };
    this.onInput = this.onChange;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  validate(c: AbstractControl): { [key: string]: any } {
    return areaCodeValidator(c);
  }
}

/** Ersetzt 2 führende "00" durch "+"
 *
 * @param value Country Code
 * @return A string with replaced 2 leading zeros (eg. 0043 -> +43)
 * */
export function replaceLeadingDoubleZeroWithPlus(value: string): string {
  return value.replace(new RegExp('^00'), '+');
}

export function areaCodeValidator(control: AbstractControl): { [key: string]: any } {
  const regex = /^(\+|00)[1-9][0-9]*$/;
  const valid = !control.value || regex.test(control.value);
  return valid ? null : { 'Ländervorwahl muss mit + oder 00 beginnen': true };
}
